import dayjs from "dayjs";
import { get as _get } from "lodash";
const streamURL = "https://dublab.out.airtime.pro/dublab_a";

export default {
  state: {
    stream: {
      url: streamURL,
      combo: "Loading…",
      title: "",
      host: "",
      loaded: false,
      paused: true,
    },
    broadcast: {
      title: "",
      url: "",
      pageUrl: "",
      paused: true,
      active: false,
      duration: 0,
      position: 0,
    },
    schedule: new Map(),
    nowPlaying: {},
    upNext: {},
    video: {
      active: false,
    },
    wasStreamPaused: false,
    playing: {
      on_air: {
        combo: "",
        start: 0,
        end: 0,
      },
      up_next: {
        combo: "",
        start: 0,
        end: 0,
      },
    },
  },
  getters: {
    getSchedule: (state) => () => state.schedule,
    getPost: (state) => (id) => state.schedule.get(id),
    getNowPlaying: (state) => () => state.nowPlaying,
  },
  mutations: {
    setBroadcastSeek(state, data = "") {
      state.broadcast.position = data;
    },
    setBroadcastMeta(state, data = {}) {
      Object.keys(data).forEach((key) => {
        state.broadcast[key] = data[key];
      });
    },
    setStreamMeta(state, data = {}) {
      Object.keys(data).forEach((key) => {
        state.stream[key] = data[key];
      });
    },
    setPlayingMeta(state, data = {}) {
      state.playing.on_air = data.current;
      state.playing.up_next = data.next;
    },
    setSchedule(state, data = []) {
      state.schedule = data.reduce(
        (acc, cur) => acc.set(cur.id, cur),
        new Map()
      );
    },
    setShow(state, show = {}) {
      state.schedule = new Map(state.schedule).set(show.id, show);
    },
    setAudio(state, data = {}) {
      if (state.broadcast.paused) {
        state.wasStreamPaused = state.stream.paused;
      }

      Object.keys(data).forEach((key) => {
        state[key] = Object.assign({}, state[key], data[key]);
      });
    },
    setState(state, data = {}) {
      Object.keys(data).forEach((key) => {
        state[key] = Object.assign({}, state[key], data[key]);
      });
    },
    setNowPlaying(state, data = {}) {
      state.nowPlaying = data;
    },
    setUpNext(state, data = {}) {
      state.upNext = data;
    },
  },
  actions: {
    toggleStream({ commit, state, rootState }) {
      commit("setAudio", {
        broadcast: { paused: true },
        stream: { paused: !state.stream.paused },
        video: isVideoMuted(rootState) ? {} : { active: false },
      });
    },
    closeBroadcast({ commit, state }) {
      commit("setAudio", {
        broadcast: {
          paused: true,
          active: false,
          url: "",
          title: "",
          duration: 0,
          position: 0,
        },
        stream: { paused: state.wasStreamPaused },
      });
    },
    loadBroadcast({ commit }, data = {}) {
      commit("setAudio", {
        broadcast: {
          paused: false,
          url: data.url,
          pageUrl: data.pageUrl,
          title: data.title,
          active: true,
          duration: 0,
          position: 0,
        },
        stream: { paused: true },
      });
    },
    toggleBroadcast({ commit, state }) {
      commit("setAudio", {
        broadcast: { paused: !state.broadcast.paused },
        stream: { paused: true },
      });
    },
    pauseBroadcast({ commit, rootState }) {
      commit("setAudio", {
        broadcast: { paused: true },
        stream: { paused: true },
        video: isVideoMuted(rootState) ? {} : { active: false },
      });
    },
    playBroadcast({ commit, rootState }) {
      commit("setAudio", {
        broadcast: { paused: false },
        stream: { paused: true },
        video: isVideoMuted(rootState) ? {} : { active: false },
      });
    },


    //  step 1

    refreshBroadcast({ commit, dispatch }) {
      const searchParams = {
        tz: getClientTimezone(),
      };
      const urlParams = new URLSearchParams(window.location.search);
      const ignoreCache = urlParams.get("ignore_cache");
      if (ignoreCache) {
        searchParams["ignoreCache"] = true;
      }

      fetch(
        "/.netlify/functions/schedule?" + new URLSearchParams(searchParams),
        {
          mode: "no-cors",
        }
      )
        .then((resp) => resp.json())
        .then((data) => {
          // filter all posts that have 'TBD' in summary
          const filteredData = data.filter((post) => {
            return !post.summary.includes('TBD')
          })
          commit("setSchedule", filteredData);
          dispatch("updateNowPlaying");
        });
    },
    getPost({ commit }, eventId) {
      let fetchUrl = `/.netlify/functions/schedule_single_event?id=${eventId}`;
      const urlParams = new URLSearchParams(window.location.search);
      const ignoreCache = urlParams.get("ignore_cache");
      if (ignoreCache) {
        fetchUrl += `&` + new URLSearchParams({ ignoreCache: true });
      }
      fetch(fetchUrl, {
        mode: "no-cors",
      })
        .then((resp) => resp.json())
        .then((data) => {
          commit("setShow", data);
        });
    },
    seekBroadcast({ commit }, data = {}) {
      commit("setBroadcastSeek", data);
    },
    updateBroadcastMeta({ commit }, data = {}) {
      commit("setBroadcastMeta", data);
    },
    updateAudio({ commit }, data = {}) {
      commit("setAudio", data);
    },
    toggleVideo({ commit, state, rootState }) {
      commit("setState", {
        video: { active: !state.video.active },
      });

      if (isVideoMuted(rootState)) {
        // if you turn on video, and live stream is paused, play the stream
        if (
          state.video.active &&
          state.stream.paused &&
          state.broadcast.paused
        ) {
          commit("setAudio", {
            broadcast: { paused: true },
            stream: { paused: false },
          });
        }
      } else {
        commit("setAudio", {
          broadcast: { paused: true },
          stream: { paused: true },
        });
      }
    },

    //  step 2

    updateNowPlaying({ state, commit }) {
      const { current, next } = getNowPlaying(state.schedule);
      console.log('state.schedule:', state.schedule)
      commit("setNowPlaying", current);
      commit("setUpNext", next);
      commit(
        "setStreamMeta",
        Object.assign({ loaded: true }, formatMetaData(current))
      );
      commit("setPlayingMeta", {
        current: formatMetaData(current),
        next: formatMetaData(next),
      });
    },
  },
};

function isVideoMuted(rootState) {
  let videoMuted = false;
  try {
    videoMuted = rootState.content["star"].livevideo.muted;
  } catch (e) {
    videoMuted = false;
  }
  return videoMuted;
}

function formatMetaData(current) {
  if (current) {
    const artist = _get(current, "eventTitleMeta.artist", "");
    const eventName = _get(current, "eventTitleMeta.eventName", "");

    const combo =
      artist && eventName
        ? `${artist} - ${eventName}`
        : artist
          ? `${artist}`
          : eventName
            ? `${eventName}`
            : "";

    return {
      combo,
      end: dayjs(current.endTime).unix(),
      host: eventName,
      start: dayjs(current.startTime).unix(),
      title: artist,
    };
  }
  return {};
}

/* get currently playing show (and upcoming) from list */
function getNowPlaying(shows) {
  const now = dayjs();
  let current;
  let next;
  let last = false;
  for (let show of shows.values()) {
    if (last) {
      next = show;
      break;
    }
    if (now > dayjs(show.startTime) && now < dayjs(show.endTime)) {
      current = show;
      last = true;
    }
  }
  return {
    current,
    next,
  };
}

function getClientTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
